import Vue from "vue";
import App from "./App.vue";
import router from "./plugins/router";
import store from "./plugins/store";
import inject from "./plugins/inject"
Vue.config.productionTip = false;
Vue.use(inject)
import {
  Loading,
  MessageBox,
  Message,
  Pagination,
  Dialog,
  Input,
  Radio,
  Select,
  Form,
  FormItem,
  Option,
  Button
} from 'element-ui'
const PLUGINS = [
  Pagination,
  Button,
  Input,
  Dialog,
  Select,
  Radio,
  Form,
  Option,
  FormItem,
]
PLUGINS.forEach(function (item) {
  Vue.use(item)
})
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");